import Layout1 from "../../components/layout/layout1";
import Box from "@mui/material/Box";
import {Paper} from "@mui/material";
import Button from "@mui/material/Button";
import {ArrowBack} from "@mui/icons-material";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {PAGE_HOME} from "../../locales/pages/namespaces";
import Typography from "@mui/material/Typography";

const Terms = ()=>{
    const history = useHistory()
    const {t} = useTranslation(PAGE_HOME)
    return(
       <Layout1>
           <Box p={1} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
               <Paper
                   elevation={0}
                   sx={{maxWidth: '600px', width: '100%', backgroundColor: 'rgba(254, 244, 217, 0.9)'}}
               >
                   <Box p={1}>
                       <Box display={'flex'} justifyContent={'space-between'} mb={1}>
                           <Button
                               variant={'contained'}
                               onClick={() => history.push('/')}
                           >
                               <ArrowBack fontSize={'small'}/>
                               {t('Home')}
                           </Button>
                       </Box>
                       <Box sx={{width:'100%',display:"flex",bgcolor:'#FFFFFF'}}>
                           <Typography sx={{p:1}}>{t('"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."')}</Typography>
                       </Box>
                   </Box>
               </Paper>
           </Box>
       </Layout1>
    )
}
export default Terms